import { Card } from "@/components/ui/card";
import { MessageSquare, PenTool, Bot } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  
  const specialties = [
    {
      icon: MessageSquare,
      title: t("about.specialties.conversational.title"),
      description: t("about.specialties.conversational.description"),
    },
    {
      icon: PenTool,
      title: t("about.specialties.uxWriting.title"),
      description: t("about.specialties.uxWriting.description"),
    },
    {
      icon: Bot,
      title: t("about.specialties.ai.title"),
      description: t("about.specialties.ai.description"),
    },
  ];
  return (
    <section id="about" className="py-24 bg-secondary/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            {t("about.title")}
          </h2>
          <p className="text-muted-foreground text-lg">
            {t("about.subtitle")}
          </p>
          <div className="w-20 h-1 bg-primary mx-auto mt-6" />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {specialties.map((specialty, index) => {
            const Icon = specialty.icon;
            return (
              <Card
                key={index}
                className="p-8 gradient-premium border-t-4 border-t-primary hover:shadow-glow transition-all duration-300 hover:-translate-y-2 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-16 h-16 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                  <Icon className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold mb-3">{specialty.title}</h3>
                <p className="text-muted-foreground leading-relaxed">
                  {specialty.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
